import { Drawer, Grid } from "antd/lib";
import React, { Dispatch, ReactNode, SetStateAction } from "react";
import styles from "@/src/components/MaterialsLibrary/MaterialsLibrary.module.scss";

const { useBreakpoint } = Grid;

interface FilterWrapperProps {
  children: ReactNode;
  isDrawerOpen: boolean;
  setIsDrawerOpen: Dispatch<SetStateAction<boolean>>;
}

const FilterWrapper: React.FC<FilterWrapperProps> = ({ children, isDrawerOpen, setIsDrawerOpen }) => {
  const screens = useBreakpoint();

  return screens.xl ? (
    <>{children}</>
  ) : (
    <Drawer
      open={isDrawerOpen}
      placement={screens.sm ? "right" : "bottom"}
      styles={{
        header: { justifyContent: "flex-end", padding: "24px 16px 0", border: "none" },
        body: { padding: "24px 16px" },
      }}
      onClose={() => setIsDrawerOpen(false)}
      className={styles.sidebar}
    >
      {children}
    </Drawer>
  );
};

export default FilterWrapper;
